<template>
  <BaseChecklist
    v-bind="$attrs"
    v-model="modelValue"
    :loading="isFetching"
    :options="options"
    label="TPA Names"
    :search-keys="['text']"
    searchable
  />
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

import { useCurrentUser, useRLSGroup, useUserCompanyRLS } from '@composables'
import { BaseChecklist } from '@components/base'

export default defineComponent({
  name: 'BDXWizardTPANames',
  components: {
    BaseChecklist
  },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  emits: ['input'],
  setup(props, { emit }) {
    const { isSuperUser } = useCurrentUser()

    const { isFetching, rlsGroupItems } = useRLSGroup('TPA')
    const { tpaIds } = useUserCompanyRLS()

    const options = computed(() =>
      rlsGroupItems.value
        .filter((rlsGroupItem) => {
          if (isSuperUser.value) return true

          return tpaIds.value.includes(rlsGroupItem.id)
        })
        .map((rlsGroupItem) => ({
          value: rlsGroupItem.id,
          text: rlsGroupItem.TPA
        }))
    )

    const modelValue = computed({
      get: () => props.value,
      set: (newValue) => emit('input', newValue)
    })

    return {
      isFetching,

      options,
      modelValue
    }
  }
})
</script>
